export const teamMemberSchedulingQueryKeys = {
  all: ['team-member-scheduling'] as const,
  assignments: (projectId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'assignments', projectId] as const,
  assignmentsWindow: (startAt: string, endAt: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'assignments-window', startAt, endAt] as const,
  myAssignmentsWindow: (startAt: string, endAt: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'my-assignments-window', startAt, endAt] as const,
  openTeamMemberNeedsWindow: (startAt: string, endAt: string) =>
    [
      ...teamMemberSchedulingQueryKeys.all,
      'open-team-member-needs-window',
      startAt,
      endAt,
    ] as const,
  teamMemberAvailabilityStatus: (userId: string, startAt: string, endAt: string) =>
    [
      ...teamMemberSchedulingQueryKeys.all,
      'team-member-availability-status',
      userId,
      startAt,
      endAt,
    ] as const,
  availableTeamMembers: (startAt: string, endAt: string, roleLabel?: string) =>
    [
      ...teamMemberSchedulingQueryKeys.all,
      'available-team-members',
      startAt,
      endAt,
      roleLabel ?? '',
    ] as const,
  teamMemberNeeds: (projectId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'team-member-needs', projectId] as const,
  resourceMargin: (projectId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'resource-margin', projectId] as const,
  inventoryFulfillmentPreview: (projectId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'inventory-fulfillment-preview', projectId] as const,
  inventoryKits: () => [...teamMemberSchedulingQueryKeys.all, 'inventory-kits'] as const,
  inventoryFulfillmentGroups: () =>
    [...teamMemberSchedulingQueryKeys.all, 'inventory-fulfillment-groups'] as const,
  inventoryGroupReservations: (projectId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'inventory-group-reservations', projectId] as const,
  weeklyAvailability: (userId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'weekly-availability', userId] as const,
  outOfOffice: (filters?: { userId?: string; status?: string }) =>
    [...teamMemberSchedulingQueryKeys.all, 'out-of-office', filters ?? {}] as const,
  itemUnavailability: (itemId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'item-unavailability', itemId] as const,
  crewSchedulingSettings: (businessId: string) =>
    [...teamMemberSchedulingQueryKeys.all, 'crew-scheduling-settings', businessId] as const,
};
